import * as React from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";
import { Icon } from "components/common";
import { ConfirmDialog } from "security-app/components/common/Modal";
import CustomFields from "security-app/components/Assets/AssetModals/AssetDetailsDrawer/MachineData/CustomFields";
import CustomFieldForm from "./CustomFieldForm";
const ShowNewFormButton = styled.a.attrs({ role: "button", "aria-label": "Show New Form" })`
  position: sticky;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  top: -16px;
  margin: 0;
  z-index: 1;
  padding: 6px 12px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.global.background};
  color: ${({ theme }) => theme.colors.text.primary};
  width: 100%;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: none;
  }
`;
function Step3() {
  var _a;
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const [selectedField, setSelectedField] = useState();
  const [showNewCustomFieldForm, setShowNewCustomFieldForm] = useState(false);
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);
  const onDelete = (fieldName) => {
    var _a2;
    const field = { [fieldName]: (_a2 = values.details) == null ? void 0 : _a2.custom_fields[fieldName] };
    setSelectedField(field);
    setShowConfirmDeleteDialog(true);
  };
  const onEdit = (fieldName) => {
    var _a2, _b;
    const existingCustomField = { ...((_a2 = values.details) == null ? void 0 : _a2.custom_fields) || {} };
    const field = { [fieldName]: (_b = values.details) == null ? void 0 : _b.custom_fields[fieldName] };
    delete existingCustomField[fieldName];
    setFieldValue("details.custom_fields", existingCustomField);
    setSelectedField(field);
    setShowNewCustomFieldForm(true);
  };
  const onCancelDelete = () => {
    setSelectedField(void 0);
    setShowConfirmDeleteDialog(false);
  };
  const deleteCustomField = () => {
    var _a2, _b;
    const fieldName = Object.keys(selectedField)[0];
    (_a2 = values.details) == null ? true : delete _a2.custom_fields[fieldName];
    setFieldValue("details.custom_fields", (_b = values.details) == null ? void 0 : _b.custom_fields);
    setFieldTouched("details.custom_fields", true);
    setSelectedField(void 0);
    setShowConfirmDeleteDialog(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showNewCustomFieldForm ? /* @__PURE__ */ React.createElement(
    CustomFieldForm,
    {
      customField: selectedField,
      setShowNewCustomFieldForm,
      setSelectedField
    }
  ) : /* @__PURE__ */ React.createElement(ShowNewFormButton, { onClick: () => setShowNewCustomFieldForm(true) }, /* @__PURE__ */ React.createElement("span", null, "Add New Field"), /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "sm" })), /* @__PURE__ */ React.createElement(CustomFields, { customFields: (_a = values.details) == null ? void 0 : _a.custom_fields, onEdit, onDelete }), showConfirmDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: "Delete Custom Field",
      onConfirm: deleteCustomField,
      onCancel: onCancelDelete,
      confirmText: "Delete"
    },
    "Are you sure you want to delete this custom field?"
  ));
}
export default Step3;
